// extracted by css-extract-rspack-plugin
export default {"container":"container-lmJ_wN","footer":"footer-O_BNQe","searchSection":"searchSection-dUSMZD"};